import { css } from 'lit';
export default css `
    :host {
        --icon-color: var(--color-primary);
        --app-bar-background-color: var(--color-ui-08);
        --app-bar-box-shadow: var(--surface-elevated-small);
        --app-bar-border-bottom: none;
        --app-bar-border-top: none;
        --app-bar-gutter: var(--gutter-s);
        --app-bar-inner-height: 2.75rem;
        --app-bar-inner-max-width: var(--max-width);
        --app-bar-inner-vertical-padding: var(--spacing-s);
        --app-bar-top-offset-display: block;

        background-color: var(--app-bar-background-color);
        display: block;
        border-bottom: var(--app-bar-border-bottom);
        border-top: var(--app-bar-border-top);
        box-shadow: var(--app-bar-box-shadow);
        padding: 0 var(--app-bar-gutter);
    }

    :host([form-factor='tablet']),
    :host([form-factor='desktop']) {
        padding: 0;
    }

    :host([form-factor='desktop']) {
        --app-bar-top-offset-display: none;
        --app-bar-inner-vertical-padding: var(--spacing-m);
        --app-bar-gutter: var(--gutter-m);
    }

    .top-offset {
        height: var(--top-offset-height, 0);
        display: var(--app-bar-top-offset-display);
        box-sizing: border-box;
        max-width: var(--app-bar-inner-max-width);
        width: 100%;
    }

    .inner,
    .bottom {
        max-width: var(--app-bar-inner-max-width);
        margin: 0 auto;
        padding: 0;
    }

    :host([form-factor='tablet']) .inner-container,
    :host([form-factor='desktop']) .inner-container {
        padding: 0 var(--app-bar-gutter);
        border-bottom: 1px solid var(--color-ui-06);
    }

    .inner {
        min-height: var(--app-bar-inner-height);
        padding: var(--app-bar-inner-vertical-padding) 0;
        display: grid;
        grid-template-columns: minmax(0px, 1fr) minmax(0px, 2fr) minmax(0px, 1fr);
    }

    :host([form-factor='mobile']) .inner {
        align-items: center;
        padding: var(--spacing-xxs) 0;
    }

    .center-section {
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
    }

    .right-section {
        justify-self: flex-end;
    }

    .mobile-title {
        flex: 1;
        text-align: center;
    }

    :host([form-factor='desktop']) .mobile-title {
        display: none;
    }

    .logo {
        display: block;
        width: 183px;
        height: 48px;
        margin: auto;
    }

    :host([form-factor='mobile']) .logo {
        width: var(--icon-size-xl);
        height: var(--icon-size-xl);
    }
`;
